$(document).ready(function () {
    var anchors = document.querySelectorAll('a[href^="#"]');

    anchors.forEach(element => {
        var id = element.getAttribute("href");

        if (id.length > 1) {
            id = id.substring(1);

            var target = document.querySelector("#" + id);
            if (target != null && target != undefined) {
                target.classList.add("in-page-target");
                $(element).click(function () {
                    stickyNavTarget(target);
                });
            }
        }
    });
});

function stickyNavTarget(target) {
    var stickyNav = document.querySelector(".sticky-header") || null;

    if (stickyNav === null) {
        target.classList.add("in-page-target-lg");
    } else {
        target.classList.remove("in-page-target-lg");
    }
}